import { mutationOptions, type QueryClient } from '@tanstack/react-query';

import { excludeCreator, restoreExcludedCreator } from './api';
import { excludeListQueryKeys } from './query-keys';

export function excludeCreatorMutationOptions(queryClient: QueryClient, workspaceId: string) {
  return mutationOptions({
    mutationFn: (creatorId: string) => excludeCreator({ workspaceId, creatorId }),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: excludeListQueryKeys.all(workspaceId),
      });
    },
  });
}

export function restoreExcludedCreatorMutationOptions(
  queryClient: QueryClient,
  workspaceId: string,
) {
  return mutationOptions({
    mutationFn: (creatorId: string) => restoreExcludedCreator({ workspaceId, creatorId }),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: excludeListQueryKeys.all(workspaceId),
      });
    },
  });
}
